import { NgModule } from '@angular/core';
import { NcTextareaComponent } from './nc-textarea/nc-textarea.component';
import {CommonModule} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ReactiveFormsModule} from '@angular/forms';
import {NcSharedModule} from 'nc-shared';
import {TextFieldModule} from '@angular/cdk/text-field';
import {MatInputModule} from '@angular/material/input';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [NcTextareaComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    TextFieldModule,
    MatInputModule,
    NcSharedModule,
    TranslateModule
  ],
  exports: [NcTextareaComponent]
})
export class NcTextareaModule { }
